/* eslint-disable */

import React from "react";
import StockProfitLossCalculator from "../features/stock-profit-loss-calculator/view";

function Section() {
  return <StockProfitLossCalculator />;
}

export default Section;
